import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { startCase, get } from "lodash";
import { Avatar, Flex, StyledLink } from "orcs-design-system";
import { themeGet } from "@styled-system/theme-get";
import Logo from "../Logo";

const Bar = styled(Flex).attrs({
  forwardedAs: "header",
  alignItems: "center",
})`
  width: 100%;
  height: ${themeGet("appScale.navBarSize")};
  padding: 0 ${themeGet("space.r")};
  background: ${themeGet("colors.black")};
  position: sticky;
  top: 0;
  z-index: 12;
`;

const AppName = styled(Flex).attrs({ alignItems: "center" })`
  font-size: ${themeGet("fontSizes.3")};
  color: ${themeGet("colors.white")};
`;

const EmptyAppNav = ({ user }) => {
  const name = get(user, "name", "");
  const picture = get(user, "picture", "");
  const formattedUserName = startCase(name);

  return (
    <Bar>
      <Flex alignItems="center">
        <AppName>
          <StyledLink block to="/">
            <Logo />
          </StyledLink>
        </AppName>
      </Flex>
      <Flex alignItems="center" ml="auto">
        <Avatar
          sizing="small"
          title={formattedUserName}
          image={picture}
          imageAlt={formattedUserName}
        />
      </Flex>
    </Bar>
  );
};

EmptyAppNav.propTypes = {
  logout: PropTypes.func,
  user: PropTypes.object,
};

export default EmptyAppNav;
